<template>
  <div class="crm-query-container" v-if="de">
    <div class="query-detail-row">
      <div class="field-container">
        <label class="query-label">
          {{ getMessageText(messages.SCALE) }}
        </label>
        <div class="selection">{{ getTextWithDefault(de.scale) }}</div>
      </div>

      <div class="field-container">
        <label class="query-label">
          {{ getMessageText(messages.DATA_TYPE) }}
        </label>
        <div class="selection">{{ getTextWithDefault(de.dataType) }}</div>
      </div>
    </div>

    <div class="query-detail-row">
      <div class="field-container">
        <label class="query-label">
          {{ $t("accountIds") }}
        </label>
        <div class="selection">{{ accountIdsText }}</div>
      </div>

      <div class="field-container">
        <label class="query-label">
          {{ $t("limit") }}
        </label>
        <div class="selection">{{ getTextWithDefault(de.limit) }}</div>
      </div>
    </div>

    <div class="query-detail-row">
      <div class="field-container">
        <label class="query-label">
          {{ getMessageText(messages.START_DATE) }}
        </label>
        <div class="selection">{{ startDateText }}</div>
      </div>

      <div class="field-container">
        <label class="query-label">
          {{ getMessageText(messages.END_DATE) }}
        </label>
        <div class="selection">{{ endDateText }}</div>
      </div>
    </div>

    <div class="query-detail-row">
      <div class="field-container">
        <label class="query-label">
          {{ $t("sort") }}
        </label>
        <div class="selected-fields">
          <ul>
            <li v-for="field in sorts" :key="field.name">
              <span class="key-label">{{ field.key.label }}</span>
              <span class="sort-dir">{{ field.sortDir.text }}</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import utils from "@/utils";

  export default {
    name: "SalesView",
    props: {
      deId: String,
      appId: String
    },
    computed: {
      ...mapState({
        apps: "apps",
        messages: "messages"
      }),
      de() {
        let elem = this;
        let app = elem.apps.find(app => {
          return app.uuid === elem.appId;
        });

        return app.dataElements[elem.deId];
      },
      accountIdsText() {
        return utils.findExpressionLabel(this.de.accountIds);
      },
      startDateText() {
        return utils.findExpressionLabel(this.de.startDate);
      },
      endDateText() {
        return utils.findExpressionLabel(this.de.endDate);
      },
      sorts() {
        return this.de.sort || [];
      }
    },
    methods: {
      getTextWithDefault(val) {
        return val || "";
      }
    }
  };
</script>

<style scoped>
  .selected-fields {
    display: inline-block;
    flex-basis: 75%;
  }

  .selected-fields ul {
    list-style-type: none;
    padding-left: 0;
  }

  .selected-fields li {
    display: flex;
  }

  .selected-fields .key-label {
    flex-basis: 50%;
  }

  .selected-fields .sort-dir {
    flex-basis: 50%;
  }

  .field-container {
    display: flex;
    flex-basis: 50%;
  }

  .selection {
    display: inline-block;
  }

  .query-detail-row {
    display: flex;
  }

  .query-label {
    font-size: 0.85rem;
    font-weight: bold;
    flex-basis: 25%;
  }
</style>
